import {
    WHOLESALE_CUSTOMER_SUCCESS,
    WHOLESALE_CUSTOMER_LOADING,
  } from '../actions/WholesaleCustomerAction';
  
  const initialState = {
    customerData: [],
    isLoading: true
  };
  
  const WholesaleCustomerReducer = (state = initialState, action = {}) => {
    switch (action.type) {
      case WHOLESALE_CUSTOMER_SUCCESS:
        return { ...state, customerData: action.data, isLoading: false };
      case WHOLESALE_CUSTOMER_LOADING:
        return { ...state, isLoading: action.isLoading };
      default:
        return state;
    }
  };
  
  export default WholesaleCustomerReducer;
  